// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"600":"f02fe178","657":"e6f75f12"}[chunkId] + ".chunk.css";
};